module.exports = __webpack_public_path__ + "img/bg1.047fd175.png";